import styled from 'styled-components/macro';
import TooltipModalLink from '../../../../TooltipModal/TooltipModalLink';

const RenderModal = styled(TooltipModalLink)`
  color: ${({ theme }) => theme.colors.colorGreen};
  font-weight: bold;
  line-height: 1.5em;
  margin-bottom: 1.5em;
  display: block;
`;

export default RenderModal;
